export default "__VITE_ASSET__g3D4bU_n__"